var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1288 14.1409L11.8636 10.8757C12.7238 9.80035 13.2381 8.43635 13.2381 6.95222C13.2381 3.48071 10.4239 0.666504 6.9524 0.666504C3.4809 0.666504 0.666687 3.48071 0.666687 6.95222C0.666687 10.4237 3.4809 13.2379 6.9524 13.2379C8.43654 13.2379 9.80054 12.7236 10.8759 11.8634L14.1411 15.1286C14.4138 15.4014 14.856 15.4014 15.1288 15.1286C15.4015 14.8559 15.4015 14.4137 15.1288 14.1409ZM11.8413 6.95222C11.8413 9.65228 9.65246 11.8411 6.9524 11.8411C4.25234 11.8411 2.06351 9.65228 2.06351 6.95222C2.06351 4.25216 4.25234 2.06333 6.9524 2.06333C9.65246 2.06333 11.8413 4.25216 11.8413 6.95222Z",
    fill: "#333333",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.1d5d434bd56c76ca1c2455e0fa53ec6d.svg";
export { ForwardRef as ReactComponent };